<div [@fadeInOut] class="notification" [ngClass]="notification.category ? 'is-' + notification.category : ''" *ngFor="let notification of notifications; let i = index;">
    <button class="delete" (click)="deleteNotification(i)"></button>
    <p class="notification__text">
        {{notification.text}}
    </p>
</div>